import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/weddingDressCooperation20220409/banner.png'
import navColor from '../../assets/weddingDressCooperation20220409/nav/color.png'
import navBg from '../../assets/weddingDressCooperation20220409/nav/nav_bg.png'
import navBgFixed from '../../assets/weddingDressCooperation20220409/nav/nav_bg_fixed.png'

import far1 from '../../assets/weddingDressCooperation20220409/nav/far1.png'
import far1_active from '../../assets/weddingDressCooperation20220409/nav/far1_active.png'
import far2 from '../../assets/weddingDressCooperation20220409/nav/far2.png'
import far2_active from '../../assets/weddingDressCooperation20220409/nav/far2_active.png'
import far3 from '../../assets/weddingDressCooperation20220409/nav/far3.png'
import far3_active from '../../assets/weddingDressCooperation20220409/nav/far3_active.png'
import son1 from '../../assets/weddingDressCooperation20220409/nav/son1.png'
import son1_active from '../../assets/weddingDressCooperation20220409/nav/son1_active.png'
import son2 from '../../assets/weddingDressCooperation20220409/nav/son2.png'
import son2_active from '../../assets/weddingDressCooperation20220409/nav/son2_active.png'
import son3 from '../../assets/weddingDressCooperation20220409/nav/son3.png'
import son3_active from '../../assets/weddingDressCooperation20220409/nav/son3_active.png'
import son4 from '../../assets/weddingDressCooperation20220409/nav/son4.png'
import son4_active from '../../assets/weddingDressCooperation20220409/nav/son4_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(84),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(94),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(94),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `0 ${calcRemFn(29)}`
  },
  topBtnBaseCss: {
    width: calcRemFn(106),
    height: calcRemFn(53)
  },
  bottomBtnLayout: {
    padding: ` ${calcRemFn(10)} ${calcRemFn(35)}`,
    'justify-content': 'flex-start'
  },
  bottomBtnBaseCss: {
    width: calcRemFn(69),
    height: calcRemFn(15),
    marginTop: calcRemFn(-6),
    marginLeft: calcRemFn(8)
  }
}

const navData = {
  // weddingDressCooperation20220409Spec: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top2',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ]
  }
}
// 情侣
const LOVERS_ID = 93179;
// 单人
const PERSONAL_ID = 93193;
// 我爱我
const I_LOVE_ME_ID = PERSONAL_ID
const pictureList = [
  {
    key: '1_1',
    picNum: 3,
    pid: LOVERS_ID
  },
  {
    key: '1_2',
    picNum: 2,
    pid: LOVERS_ID
  },
  {
    key: '1_3',
    picNum: 2,
    pid: LOVERS_ID
  },
  {
    key: '1_4',
    picNum: 2,
    pid: LOVERS_ID
  },
  {
    key: '2_1',
    picNum: 3,
    pid: PERSONAL_ID
  },
  {
    key: '2_2',
    picNum: 2,
    pid: PERSONAL_ID
  },
  {
    key: '2_3',
    picNum: 2,
    pid: PERSONAL_ID
  },
  {
    key: '2_4',
    picNum: 2,
    pid: PERSONAL_ID
  },
  {
    key: '3_1',
    picNum: 1,
    pid: I_LOVE_ME_ID
  },
  {
    key: '3_2',
    picNum: 2,
    pid: I_LOVE_ME_ID
  },
  {
    key: '3_3',
    picNum: 2,
    pid: I_LOVE_ME_ID
  },
  {
    key: '3_4',
    picNum: 2,
    pid: I_LOVE_ME_ID
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/weddingDressCooperation20220409/ctn/${key}_${index + startIndex + 1}.png`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.push({
  son: [
    require('../../assets/weddingDressCooperation20220409/ctn/4_1_3.png')
  ],
  fun: 'toNewWedding'
})

function toNewWedding () {
  window.location.href = window.location.origin + window.location.pathname + `?t=${new Date().getTime()}#/theme/weddingDress20220409`
  // this.$router.push({ path: '/theme/newWedding' })
}

function onlonadFun (_this) {
  _this.toNewWedding = toNewWedding
}

const topDiff = {
  firstSon: '_i1',
  // top1_i1: 10,
  // top1_i2: 20,
  // top2_i1: 5,
  // top2_i2: 16,
}

export default {
  title: 'VERAWANG合作款',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
  onlonadFun
}
